import React, { useState } from "react"
import ReactDOM from "react-dom"
import styled from "styled-components"
import YoutubeModal from "../youtube-player-modal"
import PropTypes from "prop-types"
import { document } from "browser-monads"

const VideoWrapper = styled.div`
  width: 100%;
  position: relative;

  border-radius: 8px;
  overflow: hidden;
  height: 49vw;

  max-height: 209px;
  max-width: 384px;

  img {
    width: 100%;
  }

  @media (max-width: 1000px) {
    width: 100%;
    height: 49vw;
  }
`

const VideoOverlay = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.35) 0%,
    rgba(0, 0, 0, 0.35) 100%
  );
  z-index: 1;
`
const PlayButton = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60px;
  height: 60px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #1f1f23;
  font-size: 2rem;
  z-index: 2;

  @media (max-width: 420px) {
    font-size: 1.4rem;
    width: 40px;
    height: 40px;
  }
`

const ModalWrapper = styled.div`
  position: relative;
  z-index: 9999;
`

function Video({ url, alt }) {
  const [showVideo, setShowVideo] = useState(false)
  const thumbnailUrl = `${url
    .replace("www", "img")
    .replace("embed", "vi")}/maxresdefault.jpg`

  const modal = (
    <ModalWrapper>
      <YoutubeModal
        id="why10a-video"
        isOpen={showVideo}
        onClose={() => setShowVideo(false)}
        videoId={url.slice(-11)}
      />
    </ModalWrapper>
  )

  return (
    <>
      <VideoWrapper onClick={() => setShowVideo(true)}>
        <VideoOverlay />
        <img src={thumbnailUrl} alt={alt} />
        <PlayButton>▶</PlayButton>
      </VideoWrapper>
      {showVideo &&
        ReactDOM.createPortal(modal, document.getElementById("___gatsby"))}
    </>
  )
}

Video.propTypes = {
  url: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
}

export default Video
